// src/components/SessionRevokedModal.tsx
import React from 'react';
import { ShieldAlert } from 'lucide-react';

interface Props {
    onClose: () => void;
    // Cor explícita em vez de herdar var(--btn-primary) do body: assim que a
    // sessão é revogada, ProtectedRoute redireciona pra "/" na hora (a ENEM),
    // então enquanto esse modal fica aberto por cima, a classe .theme-ryan do
    // body pode não refletir mais de qual plataforma a pessoa realmente
    // estava — recebendo isRyan já resolvido no momento da revogação (ver
    // App.tsx/handleSessionRevoked), o modal acerta a cor sempre.
    isRyan?: boolean;
}

const SessionRevokedModal: React.FC<Props> = ({ onClose, isRyan = false }) => {
    const brandColor = isRyan ? '#0D3B0E' : '#042563';
    const brandColorHover = isRyan ? '#062006' : '#02163D';

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.iconWrapper}>
                    <ShieldAlert size={48} strokeWidth={1.8} color={brandColor} />
                </div>

                <h2 style={styles.title}>Sessão encerrada</h2>

                <p style={styles.message}>
                    Sua conta foi acessada em outro dispositivo. Por segurança, você foi
                    desconectado deste dispositivo.
                </p>

                <button
                    style={{ ...styles.button, background: brandColor }}
                    onMouseEnter={e => { e.currentTarget.style.background = brandColorHover; }}
                    onMouseLeave={e => { e.currentTarget.style.background = brandColor; }}
                    onClick={onClose}
                >
                    Fazer login novamente
                </button>
            </div>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    overlay: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
    },
    modal: {
        background: '#fff',
        borderRadius: 16,
        padding: '40px 32px',
        maxWidth: 420,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
    },
    iconWrapper: {
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'center',
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        margin: '0 0 12px',
        color: '#1F2937',
    },
    message: {
        fontSize: 15,
        color: '#6B7280',
        lineHeight: 1.6,
        margin: '0 0 28px',
    },
    button: {
        color: '#fff',
        border: 'none',
        borderRadius: 10,
        padding: '12px 32px',
        fontSize: 15,
        fontWeight: 600,
        cursor: 'pointer',
        width: '100%',
        transition: 'all 0.2s ease',
    },
};

export default SessionRevokedModal;